import { enumManagers } from '@chirp/enums';
import React from 'react';

import { Color, EnumTag } from '../../../components/EnumTag';
import { AccessPointType_enum } from '../../../graphql/hasura/generated';

export const AccessPointTypeEnumTag: React.FC<{ type: AccessPointType_enum}> = ({ type }) => {
  return (
    <EnumTag
      enumValue={type}
      colorMap={{
        [AccessPointType_enum.COMMON_AREA]: Color.Green,
        [AccessPointType_enum.AMENITY]: Color.Blue,
        [AccessPointType_enum.RESERVATION_ONLY]: Color.Blue,
      }}
    >
      {enumManagers.AccessPointType.getLabel(type).toUpperCase()}
    </EnumTag>
  );
};
